// Generic Messages
export const ERROR_TITLE_GENERIC = `Error`;
export const ERROR_TRY_AGAIN = `Try again`;
export const ERROR_TITLE_SORRY = `Sorry!`;

// New Conversation
export const ERROR_CONVERSATION_EXISTS = `A conversation with this user or group already exists`;
export const ERROR_USER_DOES_NOT_EXIST = `This user or group does not exist on your router. To message someone on another router, use user@router-alias`;
export const ERROR_USER_DOES_NOT_EXIST_SHORT = `This user or group does not exist`;

// File Attachment
export const ERROR_UNSUPPORTED_FILE_FORMAT = `Unsupported file format`;
export const ERROR_TITLE_FILE_TOO_LARGE = `Your file is too large`;
export const ERROR_INVALID_FILE_TYPE = `SpaceLinq for Web cannot send this type of file.`;
export const ERROR_INVALID_IMAGE_TYPE = `SpaceLinq for Web cannot send this type of image file.`;
export const ERROR_FILE_TOO_LARGE = `Your file must be under 1 MB`;
export const ERROR_FILE_NOT_PROCESSED = `Your image file could not be compressed under the 1 MB size limit. Please select another file.`;

// Send Message
export const ERROR_DESC_CANNOT_SEND_GROUP_MSG = `You cannot send this message. Check if you are a member of this group from your admin console and try again.`;
export const WEBMSG_API_GROUP_MSG_SEND_ERROR = `You are not permitted to send messages for this group`;
/** Router rejection (UsernameGateway) of a 1:1 send whose e2e_keys_version isn't the recipient's current key. */
export const WEBMSG_API_INVALID_E2EE_KEYS_ERROR = "invalid e2ee keys";

// Details
export const ERROR_MEMBER_RETRIEVAL = `Unable to load members list. Please try again later or contact an admin if the issue persists.`